import { EPersonType, EMaritalStatus, EProposalCustomerPendencies, ProposalDealershipLoginDto, ProposalModel } from '~/graphql/types'
import { clearString } from '~/utils'
import { isPendencyField } from '~/utils/proposal'

export type BaseDataForm = {
  uf: string
  name: string
  email: string
  phone: string
  document: string
  nationality: string
  dealershipId: string
  dealershipName: string
  maritalStatus: EMaritalStatus
  averageEnergyBillValue?: number
  personType: EPersonType
  consortiumId: string
  dealershipLogin: ProposalDealershipLoginDto
  fidelityMonths: number | null
  sellerUserId: string 
  supportUserId: string
}

export const BASE_DATA_FORM_INITIAL_VALUES: BaseDataForm = {
  uf: '',
  name: '',
  email: '',
  phone: '',
  document: '',
  nationality: '',
  dealershipId: '',
  consortiumId: '',
  dealershipName: '',
  averageEnergyBillValue: 0,
  personType: EPersonType.pf,
  fidelityMonths: null,
  maritalStatus: '' as EMaritalStatus,
  dealershipLogin: {
    login: '',
    password: '',
    extraPassword: ''
  },
  sellerUserId: '',
  supportUserId: ''
}

export const getProposalSolvedPendencies = (formData: BaseDataForm, proposal?: ProposalModel | null): EProposalCustomerPendencies[] => {
  const solvedPendecies: EProposalCustomerPendencies[] = []

  if (proposal) {
    const { customerRef } = proposal
    const { pendencies } = customerRef

    if (isPendencyField(EProposalCustomerPendencies.phone, pendencies) && clearString(formData.phone) !== clearString(customerRef.phone || '')) {
      solvedPendecies.push(EProposalCustomerPendencies.phone)
    }

    if (isPendencyField(EProposalCustomerPendencies.name, pendencies) && formData.name !== customerRef.name) {
      solvedPendecies.push(EProposalCustomerPendencies.name)
    }

    if (isPendencyField(EProposalCustomerPendencies.uf, pendencies) && formData.uf !== customerRef.uf) {
      solvedPendecies.push(EProposalCustomerPendencies.uf)
    }

    if (isPendencyField(EProposalCustomerPendencies.email, pendencies) && formData.email !== customerRef.email) {
      solvedPendecies.push(EProposalCustomerPendencies.email)
    }

    if (isPendencyField(EProposalCustomerPendencies.document, pendencies) && clearString(formData.document) !== clearString(customerRef.document)) {
      solvedPendecies.push(EProposalCustomerPendencies.document)
    }

    if (isPendencyField(EProposalCustomerPendencies.dealershipName, pendencies) && formData.dealershipName !== customerRef.dealershipName) {
      solvedPendecies.push(EProposalCustomerPendencies.dealershipName)
    }

    if (isPendencyField(EProposalCustomerPendencies.averageEnergyBillValue, pendencies) && formData.averageEnergyBillValue !== customerRef.averageEnergyBillValue) {
      solvedPendecies.push(EProposalCustomerPendencies.averageEnergyBillValue)
    }
  }

  return solvedPendecies
}
